<div class="live-attendance">
  <header class="la-header">
    <img
      class="la-logo"
      src="assets/public/tecgym-logo-on-dark.png"
      alt="TecGym"
    />
    <div class="la-status" [ngClass]="'la-status--' + status">
      <span class="la-status-dot"></span>
      <span class="la-status-text">{{ statusLabel }}</span>
    </div>
  </header>

  <div class="la-denied" *ngIf="!permitted">
    <i class="fa fa-lock"></i>
    <p>Live attendance is not enabled for this branch.</p>
  </div>

  <div class="la-stage" *ngIf="permitted">
    <div
      class="la-branch"
      [class.la-branch--hidden]="visible.length > 0 || queue.length > 0"
    >
      <div class="la-branch-logo" *ngIf="branchLogo">
        <img
          [src]="branchLogo"
          [alt]="branchName"
          (error)="onBranchLogoError()"
        />
      </div>
      <h2 class="la-branch-name" *ngIf="branchName">{{ branchName }}</h2>
    </div>

    <div
      class="la-grid"
      *ngIf="visible.length > 0"
      [ngClass]="'la-grid--' + visible.length"
    >
      <div
        class="la-card"
        [ngClass]="'la-card--' + card.member.status"
        [class.la-card--out]="card.leaving"
        [class.la-card--paused]="card.paused"
        [attr.data-id]="card.key"
        (mouseenter)="pauseCard(card.key)"
        (mouseleave)="resumeCard(card.key)"
        *ngFor="let card of visible; trackBy: trackByCard"
      >
        <div class="la-photo">
          <img
            [src]="memberImage(card.member)"
            [alt]="displayName(card.member)"
            (error)="onImageError($event, card.member)"
          />
        </div>

        <div class="la-info">
          <div class="la-info-top">
            <span class="la-kicker">{{ kickerLabel(card.member) }}</span>
            <span class="la-time">
              <i class="fa fa-clock-o"></i>
              {{ card.member.punchTime | date: 'hh:mm a' }}
              <span class="la-date">{{
                card.member.punchTime | date: 'd MMM'
              }}</span>
            </span>
          </div>

          <div class="la-name">{{ displayName(card.member) }}</div>

          <div class="la-chips">
            <span class="la-badge">
              <i class="fa" [ngClass]="memberStatus(card.member).icon"></i>
              {{ memberStatus(card.member).label }}
            </span>
            <span class="la-area" *ngIf="card.member.areaName">
              <i class="fa fa-map-marker"></i>
              <span class="la-area-text">{{ card.member.areaName }}</span>
            </span>
          </div>

          <div
            class="la-details"
            *ngIf="
              card.member.tagNumber != null ||
              card.member.packageName ||
              card.member.dueDate
            "
          >
            <div
              class="la-detail"
              [class.la-detail--wide]="!card.member.packageName"
              *ngIf="card.member.tagNumber != null"
            >
              <span class="la-detail-label">
                <i class="fa fa-id-card-o"></i>Member No.
              </span>
              <span class="la-detail-value">#{{ card.member.tagNumber }}</span>
            </div>
            <div
              class="la-detail"
              [class.la-detail--wide]="card.member.tagNumber == null"
              *ngIf="card.member.packageName"
            >
              <span class="la-detail-label">
                <i class="fa fa-cube"></i>Package
              </span>
              <span class="la-detail-value">{{ card.member.packageName }}</span>
            </div>
            <div
              class="la-detail la-detail--wide la-due"
              [ngClass]="'la-due--' + expiryTone(card.member.dueDate)"
              *ngIf="card.member.dueDate"
            >
              <div class="la-due-head">
                <span class="la-detail-label">
                  <i class="fa fa-calendar"></i>Due Date
                </span>
                <span
                  class="la-expiry"
                  *ngIf="packageExpiryLabel(card.member.dueDate)"
                  >{{ packageExpiryLabel(card.member.dueDate) }}</span
                >
              </div>
              <span class="la-detail-value">{{
                dueDateLabel(card.member.dueDate)
              }}</span>
            </div>
          </div>
        </div>

        <div
          class="la-countdown"
          [style.animation-duration.ms]="displayMs"
        ></div>
      </div>
    </div>
  </div>

  <footer class="la-powered" [class.la-powered--compact]="visible.length > 0">
    <span>Powered by</span>
    <a href="http://tecfolk.com/" target="_blank" rel="noopener noreferrer">
      <img src="assets/live-attendance/tecfolk-logo.png" alt="Tecfolk" />
    </a>
  </footer>
</div>
